module.exports = __webpack_public_path__ + "img/phone.87bcc871.png";